export enum CloneType {
  CLONE = 'CLONE',
  UPDATE = 'UPDATE',
}
